import type { IFetchService } from "app/services/fetchService";

import { SALES_WIDGET_ENDPOINT } from "../../../types";
import type { SignalsContainer, SignalsRequestParams } from "../types";

export const createWorkspaceSignalsApiService = (fetchService: IFetchService) => {
    return {
        /**
         * Fetches available signals for given params
         * @param params
         */
        fetchSignals(params: SignalsRequestParams): Promise<SignalsContainer> {
            return fetchService.get(`${SALES_WIDGET_ENDPOINT}/feed-statistics`, params);
        },
    };
};
